module.exports = __webpack_public_path__ + "img/generali-sigorta.68f417e9.jpg";